
export { MapView } from "/home/runner/work/mangomap/mangomap/packages/ui-components/src/components/templates/map-view/index.tsx"